export default {"src":"/account/preferences/_next/static/media/Email.2f9e29db.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};